module.exports = __webpack_public_path__ + "img/cta-strip-bg.a56d8f5d.jpg";